import { useEffect, useState } from 'react';
import { NSBanner, NSColumn, NSRow, NSSection, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentRoutes } from '../PaymentRoutes';
import { useParams } from 'react-router-dom';
import { EncodingOperation } from 'namirasoft-core';

export interface SubscriptionSuccessfulPageProps extends NSARouterMakerResult, PaymentProps
{ }

export interface SubscriptionSuccessfulPageState
{
	counter: number;
}

function SubscriptionSuccessfulPage(props: SubscriptionSuccessfulPageProps)
{
	let [state, setState] = useState<SubscriptionSuccessfulPageState>({
		counter: 10
	});
	let { id } = useParams();

	useEffect(() =>
	{
		function loop()
		{
			setState(prev => ({ ...prev, counter: state.counter-- }));
			if (state.counter === 0)
			{
				let callback = props.url.getQuery("callback");
				if (callback)
					try
					{
						callback = EncodingOperation.Base64Decode(callback);
					} catch (error)
					{
						callback = "";
					}
				if (!callback)
				{
					if (id)
						callback = PaymentRoutes.SubscriptionView(id, false, "");
					else
						callback = PaymentRoutes.SubscriptionList(false, "");
				}
				window.location.href = callback;
			}
			else
				setTimeout(loop, 1000);
		}
		loop();
		// eslint-disable-next-line
	}, []);

	return (
		<PaymentLayout {...props}
			action={{
				title: "Subscription Successful", description: "See the details of our offer and take your next action."
			}}
		>
			<NSSection>
				<NSColumn>
					<NSRow>
						<NSBanner
							imageLeft={{
								src: "https://static.namirasoft.com/image/concept/bot/payment-successful.png",
								alt: "payment successful bot"
							}}
							imageRight={null}
							title={{
								text: "Thank you for your subscription!",
								style: { color: "green" }
							}}
						/>
					</NSRow>
				</NSColumn>
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<p>
					We are pleased to inform you that your subscription has been successfully processed.
					<NSSpace size={NSSpaceSizeType.NANO} />
					Your subscription will be activated shortly.
					<NSSpace size={NSSpaceSizeType.NANO} />
					Thank you for choosing Namirasoft. We appreciate your business!
				</p>
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<h4 style={{ color: "green" }}>
					You will be redirected to where you came from in {`${state.counter}`} second(s).
				</h4>
			</NSSection>
		</ PaymentLayout >
	);
}

export default SubscriptionSuccessfulPage;